import React from "react";

import { Stack, Typography } from "@mui/material";
import { Table } from "@covertree/ui/table/Table";

import { useGetRecentQuotes } from "./useGetRecentQuotes";

export function RecentQuotes() {
  const { loading, error, quotes, columns } = useGetRecentQuotes();

  return (
    <Stack mt={3} flex={1} direction="column" spacing={3}>
      <Typography variant="h4">Recent quotes</Typography>
      <Table rows={quotes} columns={columns} error={error} loading={loading} />
    </Stack>
  );
}
